import { ReactNode } from 'react'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Modal from 'react-modal'
import { defaultModalStyle } from '@tuhi/components'

interface ModalSliceState {
    readonly isOpen?: boolean
    readonly style?: Modal.Styles
    readonly children?: ReactNode
}

const initialState: ModalSliceState = {}

export const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (
            state,
            action: PayloadAction<Omit<ModalSliceState, 'isOpen'>>
        ) => {
            state.isOpen = true
            state.style = action.payload.style ?? defaultModalStyle
            state.children = action.payload.children
        },
        closeModal: (state) => {
            state.isOpen = false
            state.style = undefined
            state.children = undefined
        },
    },
})

export const { openModal, closeModal } = modalSlice.actions

export const modalReducer = modalSlice.reducer
